/* Click Fencing - stop glass spigots reaching the cart on aluminium and mesh jobs.
 *
 * THE BUG, reproduced twice on the LIVE theme 141431406686 on 2026-09-01:
 *   flat top, 1 section, 6000mm, base mount, satin black
 *     quoted on screen   $580.11
 *     cart total         $944.13
 *     difference        +$364.02  = 6 x "Frameless Glass Pool Fencing Spigots" (variant
 *                                  41519272853598) which appear NOWHERE in the quote
 *   at 4500mm: quoted $403.46, cart $524.80, difference $121.34 = 2 spigots.
 *   The count scales with the fence, so it is systematic, not a one-off.
 *
 * A customer was being quoted $580 and charged $944. That is a 63% overcharge at checkout
 * and the single worst thing that can happen to trust in the calculator.
 *
 * WHY cf-no-spigots.js DID NOT CATCH IT. That file cleans state.quoteBreakdown and
 * state.cartItems, and both ARE clean here - verified on the live page, and the saved quote
 * stores $580.11 with no spigot line. The /cart/add.js payload is built by a DIFFERENT path
 * that recomputes its own items, and in that payload the spigot line carries
 * `_SKU: ""` - an empty SKU - so nothing keyed on SKU can see it. Cleaning the display was
 * never going to fix the cart, because the cart never read the display.
 *
 * SO THIS GUARDS THE LAST POINT BEFORE THE MONEY: the request itself. Whatever upstream
 * code decides to add, a glass spigot cannot leave an aluminium or mesh page.
 *
 * GLASS IS DELIBERATELY UNTOUCHED. Frameless glass fences really do use spigots - that is
 * how they stand up. This only ever runs on blade, flat top and PerfMesh, where Pete's rule
 * is posts and brackets, already billed per section.
 *
 * It also repairs the `_Total_Quote` property, which was recording the inflated 944.13
 * rather than the quoted 580.11 on every line - so the order notes would have disagreed
 * with the quote the customer approved even after the spigots were gone.
 *
 * NEVER BREAKS ADD TO CART. Every step is wrapped; on any error the ORIGINAL request goes
 * through untouched. An overcharge is bad, a checkout that cannot complete is worse.
 */
(function () {
  'use strict';

  // Glass keeps its spigots. Only the three that use posts are guarded.
  if (!/(blade-fence-calculator|flat-top-fence-calculator|perfmesh-fence)/.test(location.pathname)) return;
  if (window.__cfCartSpigotGuard) return;
  window.__cfCartSpigotGuard = true;

  var GLASS_SPIGOT_VARIANTS = [41519272853598];
  var SPIGOT_RE = /spigot/i;

  function isSpigot(item) {
    try {
      if (!item) return false;
      if (GLASS_SPIGOT_VARIANTS.indexOf(Number(item.id)) >= 0) return true;
      var p = item.properties || {};
      // _SKU is empty on this line, so the type label is the only usable signal.
      if (SPIGOT_RE.test(String(p._Item_Type || ''))) return true;
      if (SPIGOT_RE.test(String(p._Item_Name || p.title || ''))) return true;
      return false;
    } catch (e) { return false; }
  }

  /* The total the customer was actually shown. Preferred over arithmetic on the payload,
     which carries no prices. Falls back to leaving the property alone. */
  function quotedTotal() {
    try {
      var fc = window.glassCalculator || window.glassFencingCalculator;
      var t = fc && fc.state && fc.state.quote && fc.state.quote.total;
      return (typeof t === 'number' && isFinite(t) && t > 0) ? t : null;
    } catch (e) { return null; }
  }

  function cleanBody(raw) {
    var data;
    try { data = JSON.parse(raw); } catch (e) { return null; }
    if (!data || !Array.isArray(data.items)) return null;

    var kept = data.items.filter(function (i) { return !isSpigot(i); });
    var removed = data.items.length - kept.length;
    if (!removed) return null;              // nothing to do - leave the request alone

    var total = quotedTotal();
    if (total !== null) {
      kept.forEach(function (i) {
        try {
          if (i.properties && i.properties._Total_Quote !== undefined) {
            i.properties._Total_Quote = total.toFixed(2);
          }
        } catch (e) {}
      });
    }

    data.items = kept;
    try {
      console.warn('[cf-cart-spigot-guard] removed ' + removed +
        ' glass spigot line(s) from /cart/add on an aluminium/mesh job');
    } catch (e) {}
    return JSON.stringify(data);
  }

  var origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?/.test(url) && init && typeof init.body === 'string') {
        var cleaned = cleanBody(init.body);
        if (cleaned) {
          // Shallow copy so we never mutate the caller's own object.
          var next = {};
          for (var k in init) { if (Object.prototype.hasOwnProperty.call(init, k)) next[k] = init[k]; }
          next.body = cleaned;
          return origFetch.call(this, input, next);
        }
      }
    } catch (e) {
      // Fall through and send the original request rather than risk blocking checkout.
      try { console.error('[cf-cart-spigot-guard] passthrough after error:', e); } catch (e2) {}
    }
    return origFetch.apply(this, arguments);
  };

  /* The same payload can go out over XHR depending on the code path, so guard both. */
  try {
    var oOpen = XMLHttpRequest.prototype.open;
    var oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__cfUrl = u; return oOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (/\/cart\/add(\.js)?/.test(this.__cfUrl || '') && typeof body === 'string') {
          var cleaned = cleanBody(body);
          if (cleaned) return oSend.call(this, cleaned);
        }
      } catch (e) {}
      return oSend.apply(this, arguments);
    };
  } catch (e) {}

  try { console.log('[cf-cart-spigot-guard] installed'); } catch (e) {}
})();
